module.exports = "/shiftTasks/components/taskTemplates/templatesList/taskTemplatesList-a3eb2b.html";